// source/assets/scripts/recommendations.js
function getsessionIdtrack() {
  let sessionIdtrack2 = sessionStorage.getItem("sessionIdtrack");
  if (!sessionIdtrack2) {
    sessionIdtrack2 = crypto.randomUUID();
    sessionStorage.setItem("sessionIdtrack", sessionIdtrack2);
  }
  return String(sessionIdtrack2);
}
function isMobiledevicetrack() {
  if (window.innerWidth <= 768) {
    return "mobile";
  } else return "desktop";
}
function detectplatformtrack() {
  const userAgent = navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(userAgent)) return "iOS";
  if (/Android/i.test(userAgent)) return "Android";
  if (/Windows/i.test(userAgent)) return "Windows";
  if (/Macintosh|Mac OS X/i.test(userAgent)) return "macOS";
  return "Unknown platformtrack";
}
function addproduct(category, productId, sessionIdtrack2) {
  track(category, productId, sessionIdtrack2, platformtrack, devicetrack);
}
function track(eventType, productId, sessionIdtrack2, platformtrack2, devicetrack2) {
  const trackData = {
    event_type: eventType,
    product_id: productId,
    session_id: sessionIdtrack2,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    platformtrack: platformtrack2,
    devicetrack: devicetrack2
  };
  return fetch(
    "https://asia-south1-plasma-renderer-442106-m5.cloudfunctions.net/clicks_tracking_CF_sudathi",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": "175ead8b0e764e05a17d43fd77131511"
      },
      body: JSON.stringify(trackData)
    }
  ).then((response) => {
    response.json();
    console.log("correct track: ", eventType);
  }).catch((error) => console.error("track Error:", error));
}
var sessionIdtrack = getsessionIdtrack();
var devicetrack = isMobiledevicetrack();
var platformtrack = detectplatformtrack();
var productinviewIdtrack = "";
if (document.querySelector("custom-product-recommendations")) {
  productinviewIdtrack = document.querySelector("custom-product-recommendations").getAttribute("data-product-id");
}
var currenturltrack = new URLSearchParams(window.location.search);
var productinviewurlIdtrack = currenturltrack.get("pr_rec_pid");
console.log("pid: ", productinviewIdtrack);
console.log("purlid: ", productinviewurlIdtrack);
var observertrack = new IntersectionObserver(
  (entries, observertrack2) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !entry.target.hasAttribute("data-tracked")) {
        console.log("view tracked");
        track(
          "viewed",
          productinviewIdtrack,
          sessionIdtrack,
          platformtrack,
          devicetrack
        );
        entry.target.setAttribute("data-tracked", "true");
        observertrack2.unobserve(entry.target);
      }
    });
  },
  { root: null, rootMargin: "0px", threshold: 0.01 }
);
console.log("elem: ", document.querySelector(".recommendations-section"));
var targetElementtrack = document.querySelector(".recommendations-section");
if (targetElementtrack) {
  observertrack.observe(targetElementtrack);
}
function addtocart(eventType, productId, sessionIdtrack2, platformtrack2, devicetrack2) {
  track(eventType, productId, sessionIdtrack2, platformtrack2, devicetrack2);
}
var addToCartButtontrack = document.querySelector(".product-form__submit");
var buyNowButtontrack = document.querySelector("#gokwik-buy-now");
var addtocartpopup = document.querySelectorAll("add-to-cart");
if (addToCartButtontrack) {
  addToCartButtontrack.addEventListener("click", function() {
    if (productinviewurlIdtrack) {
      addtocart(
        "add_to_cart",
        productinviewIdtrack,
        sessionIdtrack,
        platformtrack,
        devicetrack
      );
      console.log("Add to cart clicked");
    }
  });
}
if (addtocartpopup) {
  addtocartpopup.forEach((element) => {
    element.addEventListener("click", function() {
      if (element.closest(".recommendations-section")) {
        addtocart(
          "add_to_cart",
          productinviewIdtrack,
          sessionIdtrack,
          platformtrack,
          devicetrack
        );
        console.log("Add to cart pop up clicked");
      }
    });
  });
}
if (buyNowButtontrack) {
  buyNowButtontrack.addEventListener("click", function() {
    if (productinviewurlIdtrack) {
      addtocart(
        "buy_now",
        productinviewIdtrack,
        sessionIdtrack,
        platformtrack,
        devicetrack
      );
      console.log("Buy Now clicked");
    }
  });
}
document.querySelectorAll(".recommendations-section").forEach((element) => {
  element.addEventListener("click", (event) => {
    const item = event.target;
    if (event.target.closest("add-to-cart")) {
      const productAdded = event.target.closest(".card-wrapper").dataset.productId;
      console.log("productAdded", productAdded);
      addtocart(
        "add_to_cart",
        productAdded,
        sessionIdtrack,
        platformtrack,
        devicetrack
      );
      console.log("Add to cart pop up clicked");
    }
    if (item && item.closest) {
      const clickedproduct = item.closest("li");
      if (clickedproduct) {
        const liclass = clickedproduct.classList;
        const anchor = clickedproduct.querySelector("a");
        const container = clickedproduct.closest(".recommendations-section");
        if (container) {
          const category = container.classList.contains("similar-products") ? "similar-products" : "pair-with";
          console.log("anchor: ", anchor);
          console.log("category: ", category);
          console.log("clickedproduct: ", clickedproduct);
          console.log("liclass: ", liclass);
          console.log("container: ", container);
          if (clickedproduct) {
            const anchorurl = new URL(anchor.href);
            const anchorparams = new URLSearchParams(anchorurl.search);
            const productId = anchorparams.get("pr_rec_pid");
            console.log(productId);
            addproduct(category, productId, sessionIdtrack);
          }
        }
      }
    }
  });
});
//# sourceMappingURL=recommendations.js.map
